
// Definición de defaults

export const defaultTipoCausaDiferimiento: TipoCausaDiferimientoProps = {
    idTipoCausaDiferimiento:  0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface TipoCausaDiferimientoProps{
    idTipoCausaDiferimiento:  number;
    descripcion:    string;
    activo:         boolean;
}
